import { Link } from 'react-router'

import { Button } from '@/components/ui/Button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-4 text-center">
      <p className="font-mono text-6xl font-semibold text-brand-400/40">404</p>

      <div className="max-w-md">
        <h1 className="text-xl font-semibold">Siden findes ikke</h1>
        <p className="mt-1.5 text-[13px] text-text-muted">
          Linket er måske forældet, eller siden er flyttet. Gå tilbage til overblikket for at
          fortsætte.
        </p>
      </div>

      <Button variant="primary" asChild>
        <Link to="/app/dashboard">Til overblik</Link>
      </Button>
    </div>
  )
}
